import { StaticLayout } from './static-layout'

export function TermsPage() {
  return (
    <StaticLayout title="Terms of service" description="Last updated: 2026-05-13">
      <h2>1. Acceptance</h2>
      <p>
        By using mkdn.app you agree to these Terms. If you do not agree, do not use the service.
      </p>
      <h2>2. The service</h2>
      <p>
        mkdn.app is a free collaborative markdown editor. The service is provided as-is with no
        guarantee of uptime or fitness for any particular purpose.
      </p>
      <h2>3. Your account and content</h2>
      <p>
        You may create documents anonymously or with an account. You retain ownership of all
        content you create. By sharing a document publicly you grant viewers a non-exclusive
        license to view it for as long as the share link is active.
      </p>
      <h2>4. Acceptable use</h2>
      <ul>
        <li>No spam, malware, phishing, or content that violates applicable law.</li>
        <li>No abuse of the real-time collaboration system, including automated scraping.</li>
        <li>No attempts to break the security or availability of the service.</li>
      </ul>
      <h2>5. Termination</h2>
      <p>
        We may suspend or remove documents or accounts that violate these Terms. You may delete
        your account at any time via <a href="/contact">contact</a>.
      </p>
      <h2>6. Liability</h2>
      <p>
        To the maximum extent permitted by law, mkdn.app is not liable for any indirect or
        consequential damages arising from your use of the service.
      </p>
      <h2>7. Changes</h2>
      <p>
        We may update these Terms. Material changes will be announced on this page.
      </p>
    </StaticLayout>
  )
}
